import { Box, Grid } from '@factorialco/deprecated-design-system'
import { ProjectDetailsPageSaleInvoicesPageInsightsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { InsightCard } from 'modules/project_management/components/InsightCard'

export const ProjectDetailsPageSaleInvoicesPageInsights = ({
  projectId,
  projectCurrency,
}: {
  projectId: string
  projectCurrency: string
}) => {
  const { data } = useQuery(ProjectDetailsPageSaleInvoicesPageInsightsDocument, {
    variables: { projectId },
  })

  const insights = data?.projectManagement.salesInvoicesInsightsConnection.edges[0]?.node || {
    totalInvoicedAmountCents: 0,
    draftInvoicedAmountCents: 0,
    issuedInvoicedAmountCents: 0,
  }

  const { totalInvoicedAmountCents, draftInvoicedAmountCents, issuedInvoicedAmountCents } = insights

  return (
    <Grid variant="fixed">
      <Box gridColSpan={{ xxs: 12, s: 4 }}>
        <InsightCard.Cost
          totalCost={totalInvoicedAmountCents}
          currency={projectCurrency}
          title={i18n.t('project_management.sale_invoices.insights.total')}
          titleGap="s2"
        />
      </Box>
      <Box gridColSpan={{ xxs: 12, s: 4 }}>
        <InsightCard.Cost
          totalCost={draftInvoicedAmountCents}
          currency={projectCurrency}
          title={i18n.t('project_management.sale_invoices.insights.draft')}
          titleGap="s2"
        />
      </Box>
      <Box gridColSpan={{ xxs: 12, s: 4 }}>
        <InsightCard.Cost
          totalCost={issuedInvoicedAmountCents}
          currency={projectCurrency}
          title={i18n.t('project_management.sale_invoices.insights.issued')}
          titleGap="s2"
        />
      </Box>
    </Grid>
  )
}
